import { bootstrapApplication } from '@angular/platform-browser';

import { App } from './app/app';
import { appConfig } from './app/app.config';
import { HttpsEnforcer } from './app/utils/https-enforcer.util';

// Enforce HTTPS before bootstrapping the application
HttpsEnforcer.setupAutoEnforcement();

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
